
import { Candidate } from "@/types/candidate";
import { CandidateEmbeddingStatus } from "@/components/candidates/CandidateEmbeddingStatus";

interface CandidateEmbeddingWrapperProps {
  candidate: Candidate | null;
  devMode: boolean;
  onUpdate: () => void;
}

export const CandidateEmbeddingWrapper = ({
  candidate,
  devMode,
  onUpdate
}: CandidateEmbeddingWrapperProps) => {
  if (!devMode || !candidate) {
    return null;
  }

  return (
    <CandidateEmbeddingStatus 
      candidate={candidate} 
      onUpdate={onUpdate} 
    />
  );
};
